import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function apiGet(path) {
  return axios.get(`${API}${path}`);
}

export function apiPost(path, data, config) {
  return axios.post(`${API}${path}`, data, config);
}

export function apiPut(path, data) {
  return axios.put(`${API}${path}`, data);
}

export function apiDelete(path) {
  return axios.delete(`${API}${path}`);
}
